import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { useIntl } from "react-intl";


const SavedChatsSelect = (props) => {

    let intl = useIntl();

    let label = props.label;
    label = label && label !=='' ? intl.formatMessage({ id: label }):'';

    let textAux = [];
    props.options?.forEach((option) => textAux.push(""));

    if (props.label === "How long it should be?" && props.id === "theAmount") {
        textAux = ["paragraph", "paragraphs", "paragraphs", "paragraphs"];
    }

    const renderOptions = (option, key, textAux) => {


      return <MenuItem key={key} value={option.id} selected={props.value===option.id}>{option.name ==='New Chat' ? intl.formatMessage({ id: 'New Chat' }) : option.name}</MenuItem>  
  };

    return (

    <FormControl sx={{ minWidth: 140 }}>
      <Select
        id={props.id}
        value={props.value}
        onChange={props.onChange}
        size={props.size}
        displayEmpty
        renderValue={(selected) => {
          if (!selected || selected === '') {
            return <span style={{ color: '#666' }}>{label}</span>;
          }
          const selectedOption = props.options?.find(opt => opt.id === selected);
          return selectedOption ? (selectedOption.name === 'New Chat' ? intl.formatMessage({ id: 'New Chat' }) : selectedOption.name) : label;
        }}
        sx={{
          borderRadius: '12px',
          backgroundColor: '#FFF',
          fontSize: '14px',
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#e0e0e0',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#00a271',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#00a271',
          },
          '& .MuiSelect-select': {
            textAlign: 'center',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            paddingTop: '12px',
            paddingBottom: '12px',
          },
          ...props.sx
        }}
      >
        {props.options?.map((option, key) => renderOptions(option, key, textAux[key])
        )}
      </Select>
    </FormControl>
      );
};

export default SavedChatsSelect;
